var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('BaseSection',{staticClass:"homepage-container",attrs:{"padded":""}},[_c(_setup.Bfhs,{staticClass:"hero"}),_c(_setup.TrendingMixes),_c(_setup.PremiumBanner,{attrs:{"source":"home-banner"}}),_c(_setup.HomeRadio),_c(_setup.LatestMixes),_c(_setup.FeaturedPlaylists),_c(_setup.FeaturedCharts),_c(_setup.TrendingDjs)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }